export const
    POINTS_PENDING = 'points_pending',
    POINTS_FAILED = 'points_failed',
    POINTS_DOWNLOADED = 'points_downloaded',
    POINTS_RESET = 'points_reset',
    POINT_RESET = 'point_reset',
    POINT_FOCUS = 'point_focus',
    POINT_DOWNLOADED = 'point_downloaded',
    POINT_FAILED = 'point_failed',
    POINT_DELETING = 'point_deleting',
    POINT_DELETED = 'point_deleted',
    POINT_EDITING = 'point_editing',
    POINT_POSTING = 'point_posting',
    POINT_MEDIA_FOCUS = 'point_media_focus',
    POINT_MEDIA_UPLOADING = 'point_media_posting',
    POINT_MEDIA_FAILED = 'point_media_failed',
    POINT_MEDIA_UPLOADED = 'point_media_uploaded',
    POINT_MEDIA_DELETING = 'point_media_deleting',
    POINT_MEDIA_DELETED = 'point_media_deleted';



// WEBPACK FOOTER //
// src/store/points/types.js